module.exports = __webpack_public_path__ + "media/shared/loading-7e4e31f2.gif";